import { useEffect } from 'react';
import { useForm, useFormState } from 'react-final-form';

import {
  ActionType,
  useBookingContext,
} from '../../../_common/context/BookingContext';

export default function FormEffectWatcher() {
  const [{ formEffect }, dispatch] = useBookingContext();
  const finalForm = useForm();
  const { values } = useFormState();

  useEffect(() => {
    switch (formEffect) {
      case 'RESET':
        setTimeout(() => finalForm.reset());
        break;
      case 'SUBMIT':
        setTimeout(() => finalForm.reset(values));
        break;
      default:
        break;
    }

    dispatch({ type: ActionType.DO_FORM_EFFECT, payload: null });
  }, [formEffect]);

  return null;
}
